// FIRST import on purpose: offline QA mode (`yarn qa:local`) must stub
// WebSocket before socket.io/centrifuge modules capture the real
// constructor. No-op unless VITE_QA_MOCKS=true on the dev server (see
// qa-mocks/qa-mode.ts for the production hard-disable).
import '@/test-support/qa-mocks/bootstrap';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import '@/lib/use-custom-instance';
// Side-effect import: boots the theme store so it syncs `data-theme` on <html>
// (and tracks future changes) regardless of which components read it.
import '@/store/themeStore';
import { initNativeBridge } from '@/lib/native-bridge';
import { IS_QA_MOCKS } from '@/test-support/qa-mocks/qa-mode';
import App from './App.tsx';

console.log('VITE_SOCKET_URL', import.meta.env.VITE_SOCKET_URL);

initNativeBridge();

function renderApp(): void {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

if (IS_QA_MOCKS) {
  // Offline QA (`yarn qa:local`): the MSW worker must be running before the
  // first render so no request escapes it. Dynamic import keeps msw + the
  // generated mocks out of every other build (the branch is statically dead).
  void import('@/test-support/qa-mocks/start').then(({ startQaMocks }) => startQaMocks().then(renderApp));
} else {
  renderApp();
}
